import styled from 'styled-components'

const Section = styled.section`
  margin-top: 1rem;
  &:not(:last-child) { margin-bottom: 6rem; }
  padding: 1rem;
`

export default Section



/** WEBPACK FOOTER **
 ** ./src/components/Section.js
 **/